import { Typography, IconButton } from "@material-ui/core";
import '../../styles/Globales.scss';


import React, { Component } from 'react'
import { DeleteForeverOutlined } from "@material-ui/icons";
import * as ValidationUtils from '../../utils/ValidationUtils';

export default class BtnResumen extends Component {

    onClickDelete = () => {
        if (this.props.onDelete) {
            this.props.onDelete(this.props.producto);
        }
    }

    render() {
        let botonBorrar;
        if (this.props.canDelete) {
            botonBorrar = <IconButton onClick={this.onClickDelete}>
                <DeleteForeverOutlined />
            </IconButton>;
        }
        return (
            <div className="btnResumenCarro">
                <div className="tituloBtnResumen">
                    <div>
                        <Typography>{this.props.producto.nombreProducto}</Typography>
                    </div>
                    <div>
                        <span>{ValidationUtils.formatNumeroCuenta(this.props.producto.numeroCuenta)}</span>
                    </div>
                </div>
                {botonBorrar}
            </div>

        )
    }
}

BtnResumen.defaultProps = {
    canDelete: true
}
